import { Minus, Plus } from "@phosphor-icons/react";

export default function Stepper({ value, onChange, step = 1, min = 0, max, testid = "stepper" }) {
  const inc = () => {
    const next = (Number(value) || 0) + step;
    if (max != null && next > max) return;
    onChange(next);
  };
  const dec = () => {
    const next = (Number(value) || 0) - step;
    if (next < min) return;
    onChange(next);
  };
  return (
    <div className="flex items-center gap-4 select-none">
      <button
        type="button"
        onClick={dec}
        data-testid={`${testid}-minus`}
        className="w-16 h-16 rounded-2xl bg-[color:var(--brand-muted)] text-[color:var(--brand)] flex items-center justify-center press-scale hover:bg-[#CFDED6]"
      >
        <Minus size={32} weight="bold" />
      </button>
      <input
        data-testid={`${testid}-value`}
        type="number"
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-28 h-16 text-center text-3xl font-semibold font-heading bg-white rounded-2xl border border-[color:var(--border-soft)] focus:outline-none focus:ring-2 focus:ring-[color:var(--brand)]"
      />
      <button
        type="button"
        onClick={inc}
        data-testid={`${testid}-plus`}
        className="w-16 h-16 rounded-2xl bg-[color:var(--brand)] text-white flex items-center justify-center press-scale hover:bg-[color:var(--brand-hover)]"
      >
        <Plus size={32} weight="bold" />
      </button>
    </div>
  );
}
